import { useCallback, useEffect, useState } from 'react';
import { FiservCardInterface, FiservCardStatusEnum } from '@common-fe/common-fe';

import useCardAccessModalStore from '../stores/useCardAccessModal.store';

export const useCardAccessModal = (
  card?: FiservCardInterface,
  visible?: boolean,
  onChangeCardAccessModalVisible?: () => void,
  setHideVisibility?: (value: boolean) => void,
) => {
  const [isEmployeeUnlockForbidden, setEmployeeUnlockForbidden] = useState(false);
  const [isConfirmationMode, setConfirmationMode] = useState(false);
  const {
    state: { lockedPursesIds, isCardLocked, lockReason },
    handleSetLockedPurses,
    handleToggleCardLock,
  } = useCardAccessModalStore();

  const {
    handleSetLockReason,
  } = useCardAccessModalStore();

  const handleSetConfirmationMode = useCallback(() => {
    setConfirmationMode((prev) => !prev);
  }, []);
  
  const handleCancel = useCallback(() => {
    handleSetLockReason('');
    onChangeCardAccessModalVisible?.();
    setHideVisibility?.(false);
  }, [onChangeCardAccessModalVisible, setHideVisibility, handleSetLockReason]);

  useEffect(() => {
    if (!visible) {
      setConfirmationMode(false);
    }
  }, [visible]);

  useEffect(() => () => {
    handleToggleCardLock(card?.status === FiservCardStatusEnum.FROZEN || card?.status === FiservCardStatusEnum.PENDING_FROZEN);
    if (card?.cardPurses) handleSetLockedPurses(card.cardPurses);
  }, [card?.cardPurses, card?.status, handleSetLockedPurses, handleToggleCardLock]);

  useEffect(() => {
    if (card?.employeeUnlockForbidden) {
      setEmployeeUnlockForbidden(card?.employeeUnlockForbidden);
    }
  }, [card?.employeeUnlockForbidden]);

  return {
    isConfirmationMode,
    lockedPursesIds,
    isCardLocked,
    isEmployeeUnlockForbidden,
    lockReason,
    handleSetConfirmationMode,
    handleCancel,
    handleEmployeeUnlockForbidden: setEmployeeUnlockForbidden,
  };
};
